module.exports = __webpack_public_path__ + "assets/img/mastercard.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-logos/mastercard.svg
// module id = 76
// module chunks = 0